import { Injectable, inject } from '@angular/core';
import { CandidateDetailsStore } from './candidate-details.store';
import { EventBusService, EventPayload } from 'src/app/shared/services/event-bus.service';
import { LocumsMarginCalculatorEvents } from '../enums/locums-margin-calculator-events.enum';

@Injectable({ providedIn: 'root' })
export class CandidateDetailsReducer {
    readonly candidateDetailsStore = inject(CandidateDetailsStore);
    private readonly eventBus = inject(EventBusService);

    constructor() {
        this.listenToSearchEvent();
        this.listenToLoadMarginDetailsEvent();
    }

    private listenToLoadMarginDetailsEvent() {
        this.eventBus
            .on(LocumsMarginCalculatorEvents.LOCUMS_1099_MARGIN_CALCULATOR_LOAD_MARGIN_DETAILS)
            .subscribe((event: EventPayload) => {
                this.candidateDetailsStore.updateCandidateDetailsFromData({
                    ...event.payload.marginDetails.candidateDetails,
                    candidateExpertiseId: event.payload.marginDetails.candidateExpertiseId as number,
                    expertiseId: event.payload.marginDetails.expertiseId as number,
                    expertiseYearsOfExperience: event.payload.marginDetails.expertiseYearsOfExperience as number
                });
            });
    }

    private listenToSearchEvent() {
        this.eventBus
            .on(LocumsMarginCalculatorEvents.SELECTED_CANDIDATE_EXPERTISE_ID)
            .subscribe((event: EventPayload) => {
                this.candidateDetailsStore.updateCandidateDetailsFromData({
                    candidateExpertiseId: event.payload as number
                });
            });

        this.eventBus.on(LocumsMarginCalculatorEvents.EXPERTISE_ID_CHANGED).subscribe((event: EventPayload) => {
            this.candidateDetailsStore.updateCandidateDetailsFromData({
                expertiseId: event.payload as number
            });
        });

        this.eventBus
            .on(LocumsMarginCalculatorEvents.EXPERTISE_YEARS_OF_EXPERIENCE_CHANGED)
            .subscribe((event: EventPayload) => {
                this.candidateDetailsStore.updateCandidateDetailsFromData({
                    expertiseYearsOfExperience: event.payload as number
                });
            });
    }
}
